export default __webpack_public_path__ + "static/badge-app-store-712d7de6b5b899be2862ef03697fcff7.png";